import React from "react";

const UserContext = React.createContext({usuario: null, setUsuario: null});

export default UserContext;
